import React from 'react';

import classNames from 'classnames/bind';
import style from './Fact.scss';
const ctx = classNames.bind(style);

const Fact = props => (
  <div className={ctx('fact')}>
    <div className={ctx('title')}>{props.title}</div>
    <div className={ctx('description')}>{props.description}</div>
    <div className={ctx('source')}>{props.source}</div>
  </div>
);

export default Fact;
